import { create } from 'zustand';
import { ReactNode } from 'react';

export type AlertContent = {
  content?: ReactNode;
  inlineContent?: string;
  mapPortalContent?: ReactNode;
};

type AlertState = {
  content: ReactNode | null;
  mapPortalContent: ReactNode | null;
  inlineContent: string | null;
  showAlert: (content: AlertContent) => void;
  showMapAlert: (mapPortalContent: AlertContent) => void;
  hideAlert: () => void;
};

export const useAlertStore = create<AlertState>((set) => ({
  content: null,
  mapPortalContent: null,
  inlineContent: null,
  showAlert: (content: AlertContent) => set({ ...content }),
  // showMapAlertを通るテストケースを追加してください。
  showMapAlert: (mapPortalContent: AlertContent) => set({ ...mapPortalContent }),
  hideAlert: () => set({ content: null, inlineContent: null, mapPortalContent: null }),
}));
